@if (!hasError()) {
  <canvas #canvasEl id="canvas" [width]="width()" [height]="height()"></canvas>
}
